<template>
  <div>
    <div class="cx_style status-wrapper">
      <div class="content">
        <div class="content-item verticallyCenter">
          <div v-if="label" class="fs13 mr16 title">{{ label }}</div>
          <div ref="component" class="font-arrangement-btn" v-if="showToolTip">
            <span class="btn-active" :style="getTranslate"></span>
            <el-tooltip
              v-for="(option, index) in options"
              :key="index"
              slot="label"
              class="item"
              effect="dark"
              :content="option.label"
              placement="top-end"
              :open-delay="1000"
            >
              <span
                class="fs13"
                :class="[slideDistance == option.value ? 'select pd2' : 'pd2', option.iconClass]"
                @click="changeValue(option.value)"
                >{{ option.title }}</span
              >
            </el-tooltip>
          </div>
          <div ref="component" class="font-arrangement-btn" v-else>
            <span class="btn-active" :style="getTranslate"></span>
            <span
              v-for="(option, index) in options"
              :key="index"
              class="fs13"
              :class="[slideDistance == option.value ? 'select pd2' : 'pd2', option.iconClass]"
              @click="changeValue(option.value)"
              >{{ option.title }}</span
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import "modules/common.css"
export default {
  name: "cx-label-slider",
  props: {
    label: {
      type: String,
      required: false
    },
    value: {
      type: String,
      required: true
    },
    options: {
      type: Array,
      required: true
    },
    showToolTip: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      translate: 0,
      sliderWidth: 0
    }
  },
  watch: {
    options() {
      const width = this.$refs.component.clientWidth
      this.sliderWidth = parseInt((width - 6) / this.options.length || 0)
      this.translate = 0
    }
  },
  computed: {
    slideDistance: {
      get() {
        let index = this.options.findIndex(item => item.value === this.value)
        this.translate = this.sliderWidth * index
        return this.value
      },
      set(val) {
        this.$emit("update:value", val)
      }
    },
    getTranslate() {
      return {
        width: `${this.sliderWidth}px`,
        transform: `translateX(${this.translate}px)`
      }
    }
  },
  mounted() {
    const width = this.$refs.component.clientWidth
    this.sliderWidth = parseInt((width - 6) / this.options.length || 0)
    this.translate = 0
  },
  methods: {
    changeValue(val) {
      this.slideDistance = val
      this.$emit("click")
    }
  }
}
</script>

<style scoped>
.status-wrapper .title {
  color: rgba(0, 0, 0, 0.4);
}
.font-arrangement-btn {
  flex: 1 1 0%;
}
.font-arrangement-btn span::before {
  color: #717989;
  font-size: 16px;
}
.fs13 {
  font-size: 13px !important;
}
.font-arrangement-btn span.select {
  background: var(--leftMenuBgColor) !important;
  border-radius: 3px;
  color: var(--themeColor) !important;
}
</style>
